/** The banner shown in the panel's corner while an element or region is being picked (spec section 4). */
import { createPortal } from 'react-dom';
import { Crosshair } from 'lucide-react';
import { FEEDBACK_LAYER_CLASS, anchorStyle, type Corner } from './constants';
import { cn } from '@/lib/utils';

export function PickingBanner({ corner, mode }: { corner: Corner; mode: 'element' | 'region' }) {
  return createPortal(
    <div
      role="status"
      tabIndex={-1}
      data-feedback-picking-banner=""
      data-testid="feedback-picking-banner"
      style={anchorStyle(corner)}
      className={cn(
        'fixed inline-flex items-center gap-1.5 rounded-full bg-foreground px-3 py-1.5 text-xs font-semibold text-background shadow-[var(--shadow-popover)]',
        FEEDBACK_LAYER_CLASS,
      )}
    >
      <Crosshair className="size-3.5" aria-hidden />
      {mode === 'element' ? 'Picking an element…' : 'Drawing a region…'} Esc returns to the panel
    </div>,
    document.body,
  );
}
